const hostname = window.location.hostname || 'devs.berlin'
const ghostAPI = `https://${hostname}/ghost/api/content/`
const ghostApiKey = 'c17257c725149312edf2b15c72'
const CDNSpace = 'https://cod3k.fra1.cdn.digitaloceanspaces.com/codek-website'

function initParallax() {
    jarallax(document.querySelectorAll('.has-parallax-feed .gh-card'), {
        speed: 0.8,
    });
}

function pagination(isInfinite = true, done) {
    let loading = false;
    const feedElement = document.querySelector('.gh-feed');

    if(feedElement) {
        const target = feedElement.nextElementSibling || feedElement.parentElement.nextElementSibling;

        const loadNextPage = async function () {
            const nextElement = document.querySelector('link[rel=next]');

            if (!nextElement) {
                return;
            }

            try {
                const res = await fetch(nextElement.href);
                const html = await res.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                const posts = doc.querySelectorAll('.gh-feed > *');

                posts.forEach(function (post) {
                    feedElement.appendChild(document.importNode(post, true));
                });

                if (done) {
                    done();
                }

                const resNextElement = doc.querySelector('link[rel=next]');
                if (resNextElement && resNextElement.href) {
                    nextElement.href = resNextElement.href;
                } else {
                    nextElement.remove();
                }
            } catch (e) {
                nextElement.remove();
                throw e;
            }
        };

        const callback = async function (entries) {
            if (loading) {
                return;
            }

            loading = true;

            if (entries[0].isIntersecting) {
                // keep loading next page until target is out of the viewport or we've loaded the last page
                while (target.getBoundingClientRect().top <= window.innerHeight && document.querySelector('link[rel=next]')) {
                    await loadNextPage();
                }
            }

            loading = false;

            if (!document.querySelector('link[rel=next]')) {
                observer.disconnect();
            }
        };

        const observer = new IntersectionObserver(callback);
        observer.observe(target);
    }
    
}

(function () {
    initParallax();
})();

/** comments toggle */
(function () {
    const toggle = document.querySelector('[data-toggle-comments]');
    if (!toggle) return;

    toggle.addEventListener('click', function () {
        document.body.classList.toggle('comments-opened');
    });
})();

/** portfolio filters */
(function () {
    const links = document.querySelectorAll('.work-filter a');
    if (!links || links.length < 1) return;

    console.log(links)

    // $('.work-filter a').on('click', (e) => {
    //     e.preventDefault()
    //     console.log('clicked: ', e.target)
    // })

    const filterSelection = (c) => {
        var x, i;
        x = document.getElementsByClassName("gh-card post");
        if (c == "all") c = "";
        // Add the "show" class (display:block) to the filtered elements, and remove the "show" class from the elements that are not selected
        for (i = 0; i < x.length; i++) {
            w3RemoveClass(x[i], "show");
            if (x[i].className.indexOf(c) > -1) w3AddClass(x[i], "show");
        }
    }

    // Show filtered elements
    const w3AddClass = (element, name) => {
        var i, arr1, arr2;
        arr1 = element.className.split(" ");
        arr2 = name.split(" ");
        for (i = 0; i < arr2.length; i++) {
            if (arr1.indexOf(arr2[i]) == -1) {
            element.className += " " + arr2[i];
            }
        }
    }

    // Hide elements that are not selected
    const w3RemoveClass = (element, name) => {
        var i, arr1, arr2;
        arr1 = element.className.split(" ");
        arr2 = name.split(" ");
        for (i = 0; i < arr2.length; i++) {
            while (arr1.indexOf(arr2[i]) > -1) {
            arr1.splice(arr1.indexOf(arr2[i]), 1);
            }
        }
        element.className = arr1.join(" ");
    }

    filterSelection("all") // Execute the function and show all columns

    links.forEach((item, index) => {
        item.addEventListener('click', (e) => {
            e.preventDefault()
            document.querySelector('.work-filter a.current').classList.remove('current')
            // console.log('clicked: ', e.target)
            // console.log('filter by: ', e.target.dataset.filterTag)
            const filterBy = e.target.dataset.filterTag
            console.log('filter by: ', filterBy)

            e.target.classList.add('current')
            filterSelection(filterBy) // Execute the function to filter the posts
            
        });
    })

})();

(function () {
    const element = document.querySelector('.gh-article-excerpt');
    if (!element) return;

    let text = element.textContent;
    const emojiRE = /\p{EPres}|\p{ExtPict}/gu;

    const emojis = text.match(emojiRE);
    if (!emojis) return;

    emojis.forEach(function (emoji) {
        text = text.replace(emoji, `<span class="emoji">${emoji}</span>`);
    });

    element.innerHTML = text;
})();

(function () {
    pagination(true, initParallax);
})();

/** darkmode toggle */
(function () {
    console.log('window loaded');

    const setFavicon = function (url) {
        // Find the current favicon element
        const favicon = document.querySelector('link[rel="icon"]');
        if (favicon) {
            // Update the new link
            favicon.href = url;
        } else {
            // Create new `link`
            const link = document.createElement('link');
            link.rel = 'icon';
            link.href = url;

            // Append to the `head` element
            document.head.appendChild(link);
        }
    };

    const switchTheme = (theme, toggle) => {

        const html = document.documentElement;
        const logo = document.querySelector('.gh-head-logo img');
        const aboutAvif = document.querySelector('.gh-about-picture .avif');
        const aboutWebp = document.querySelector('.gh-about-picture .webp');
        const aboutImage = document.querySelector('.gh-about-image');
        const clientLogosArray = document.querySelectorAll('.client-logos img');

        if (theme == "dark") {
            html.setAttribute("data-theme", "dark");
            html.className = 'has-light-text';
            logo ? logo.src = `${CDNSpace}/codek_logo_white_new_notext-5-squashed.png` : '';
            aboutAvif ? aboutAvif.srcset = `${CDNSpace}/IMG_3591.avif` : '';
            aboutWebp ? aboutWebp.srcset = `${CDNSpace}/IMG_3591.webp` : '';
            aboutImage ? aboutImage.src = `${CDNSpace}/IMG_3591.jpeg` : '';
            toggle.checked = true;
            clientLogosArray.forEach(clientLogo => {
                clientLogo.src = clientLogo.src.replace('gray.svg', 'invert.svg');
            });
        } else {
            html.removeAttribute("data-theme");
            html.className = 'has-dark-text';
            logo ? logo.src = `${CDNSpace}/codek_logo_dark_new_notext-5-squashed.png` : '';
            aboutAvif ? aboutAvif.srcset = `${CDNSpace}/IMG_3591-2.avif` : '';
            aboutWebp ? aboutWebp.srcset = `${CDNSpace}/IMG_3591-2.webp` : '';
            aboutImage ? aboutImage.src = `${CDNSpace}/IMG_3591-2.jpeg` : '';
            toggle.checked = false;
            clientLogosArray.forEach(clientLogo => {
                clientLogo.src = clientLogo.src.replace('invert.svg', 'gray.svg');
            });
        }

    }

    if(!document.querySelector('.dark-mode-switch')){
        const darkModeToggle = document.createElement('div');
        darkModeToggle.classList.add('dark-mode-switch');
        darkModeToggle.innerHTML = '<input type="checkbox" class="material-symbols-rounded" id="theme-toggle" /><label for="theme-toggle">Dark mode</label>';
        
        const clearSwitch = document.createElement('button');
        clearSwitch.classList.add('hide');
        clearSwitch.id = "clearLocalStorage";
        clearSwitch.innerHTML = '<span class="material-symbols-rounded delete-icon">delete</span>';
        
        document.querySelector('.gh-head-actions').append(darkModeToggle);
        document.querySelector('.gh-head-actions').append(clearSwitch);
    }
    
    try {
        var localStorageAvailable = window.localStorage !== "undefined";
    } catch (e) {
        var localStorageAvailable = false;
    }

    const themePreference = () => {
        const hasLocalStorage =
            localStorageAvailable && localStorage.getItem("theme");
        const systemPrefersDark = window.matchMedia("(prefers-color-scheme: dark)")
            .matches;

        let theme = undefined;

        if (hasLocalStorage) {
            clearLocalStorage.classList.remove("hide");
            if (hasLocalStorage === "dark") {
            theme = "dark";
            } else theme = "light";
        } else if (systemPrefersDark) {
            theme = "dark";
        } else theme = "light";

        return { theme };
    };

    const toggle = document.getElementById("theme-toggle");
    const clearLocalStorage = document.getElementById("clearLocalStorage");

    const setTheme = () => {
    if (themePreference().theme == "dark") {
        switchTheme('dark', toggle)
        setFavicon(`${CDNSpace}/codek_logo_white_new_notext-5-squashed.png`);
    } else {
        switchTheme('light', toggle)
        setFavicon(`${CDNSpace}/codek_logo_dark_new_notext-5-squashed.png`);
    }
    };

    setTheme();

    clearLocalStorage.addEventListener(
    "click",
    (e) => {
        localStorageAvailable && localStorage.removeItem("theme");
        clearLocalStorage.classList.add("hide");
        setTheme();
    },
    false
    );

    toggle.addEventListener(
    "click",
    (e) => {
        if (toggle.checked) {
            switchTheme('dark', toggle)
            localStorageAvailable && localStorage.setItem("theme", "dark");
            localStorageAvailable && clearLocalStorage.classList.remove("hide");
        } else {
            switchTheme('light', toggle)
            localStorageAvailable && localStorage.setItem("theme", "light");
            localStorageAvailable && clearLocalStorage.classList.remove("hide");
        }
    },
    false
    );
})();

/** smooth scroll */
(function () {
    // console.log(window.location.hash)
    if(window.location.hash != undefined && window.location.hash != "") {
        $('html,body').animate({scrollTop:$(window.location.hash).offset().top}, 500);
        return
    }
    $('.nav li a[href*="#"]').on('click', function(event){     
        if($(this.hash).offset().top) {
            event.preventDefault();
            // console.log($(this.hash).offset().top)
            $('html,body').animate({scrollTop:$(this.hash).offset().top}, 500);
            window.location.hash = $.attr(this, 'href').split('#')[1]
            return
        }
    });
})();

/** typeform load */
(function () {
    document.addEventListener("DOMContentLoaded", (event) => {
        // console.log("DOM fully loaded and parsed");
        const contactEl = document.querySelector('#contact')
        const subscribeEmbed = document.querySelector('.subscribe-embed')
        let hasContactBeShown = false
        let hasSubscribeBeShown = false

        /** check if scrolling sections into view? */
        document.body.onscroll = () => {
            if (contactEl && contactEl.getBoundingClientRect().top <= window.innerHeight && !hasContactBeShown) {
                hasContactBeShown = true
                const typeFormScript = document.createElement('script')
                typeFormScript.src = '//embed.typeform.com/next/embed.js'
                typeFormScript.async = true
                contactEl.append(typeFormScript)
            }

            if(subscribeEmbed && subscribeEmbed.getBoundingClientRect().top <= window.innerHeight && !hasSubscribeBeShown) {
                hasSubscribeBeShown = true
                const subscribeScript = document.createElement('script')
                subscribeScript.src = 'https://cdn.jsdelivr.net/ghost/signup-form@~0.1/umd/signup-form.min.js'
                subscribeScript.dataset.backgroundColor = '#08090c'
                subscribeScript.dataset.textColor = '#FFFFFF'
                subscribeScript.dataset.buttonColor = '#FF1A75'
                subscribeScript.dataset.buttonTextColor = '#FFFFFF'
                subscribeScript.dataset.title = '< CODE K /> Christian Koch ✌️ Code. Development. Hosting.'
                subscribeScript.dataset.description = 'knowledge of over 15 years in professional development. Web, mobile, frontend, backend, devops, code, native, apps, email, crm, journeys & more. Made with ♥️ from devs.berlin! Subscribe below to receive my latest stuff directly in your inbox 👇'
                subscribeScript.dataset.icon = 'https://cod3k.fra1.cdn.digitaloceanspaces.com/codek-website/codek_logo_white_new_notext-5-squashed.png'
                subscribeScript.dataset.site = 'https://devs.berlin/'
                subscribeScript.dataset.locale = 'en'
                subscribeScript.async = true
                subscribeEmbed.append(subscribeScript)
            }

            if(hasContactBeShown && hasSubscribeBeShown) {
                document.body.onscroll = "";
                console.log("document.body.onscroll = stopped!")
            }
            
        }

    });
})();
